import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService, AppTheme } from '../services/theme.service';

@Component({
  selector: 'cygov-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
  standalone: false,
})
export class ThemeToggleComponent implements OnInit, OnDestroy {
  currentTheme: AppTheme = 'dark-theme';
  isOnCollectionRoute = false;
  isDisabled = false;
  private subs: Subscription[] = [];

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.subs.push(
      this.themeService.currentTheme$.subscribe(theme => (this.currentTheme = theme)),
      this.themeService.isOnCollectionRoute$.subscribe(val => (this.isOnCollectionRoute = val)),
      this.themeService.isThemeToggleDisabled$.subscribe(val => (this.isDisabled = val))
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  setTheme(theme: AppTheme): void {
    if (!this.isOnCollectionRoute || this.isDisabled) {
      return;
    }
    this.themeService.setTheme(theme);
    this.themeService.saveThemePreference();
  }

  get isDark(): boolean {
    return this.currentTheme === 'dark-theme';
  }

  get isLight(): boolean {
    return this.currentTheme === 'light-theme';
  }
}
